<template>
  <div
    id="app"
    :class="{ 'tablet-mode': isTabletMode }"
  >
    <transition
      name="fade"
      mode="out-in"
      appear
    >
      <RouterView />
    </transition>
    <ViewportDebugPanel v-if="showViewportDebug" />
  </div>
</template>

<script>
  import ViewportDebugPanel from "../components/debug/ViewportDebugPanel.vue";
  import { mapGetters } from "vuex";

  export default {
    name: `App`,
    components: {
      ViewportDebugPanel,
    },
    computed: {
      ...mapGetters(["getIsTabletMode"]),
      isTabletMode() {
        return this.getIsTabletMode && this.$route.name !== "tabloid-print";
      },
      showViewportDebug() {
        const query = this.$route && this.$route.query;

        return Boolean(
          query &&
            query["viewport-debug"] === "1" &&
            this.$route.name !== "tabloid-print"
        );
      },
    },
  }
</script>
